"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkReviewProductAttributes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const bulk_review_product_attributes_mutation_1 = require("../gql/bulk-review-product-attributes.mutation");
const useBulkReviewProductAttributes = () => {
    const [mutate, { loading, error }] = (0, react_2.useMutation)(bulk_review_product_attributes_mutation_1.BULK_REVIEW_PRODUCT_ATTRIBUTES);
    const bulkReviewProductAttributes = (0, react_1.useCallback)((_a) => __awaiter(void 0, [_a], void 0, function* ({ attribute, attributeType, catalogId, productTreeNodeId, filter, presentationAttributes, presentationAttributeFilterStrategy, isReviewed, expectedMatchedProductCount, status, clientMutationId = '', }) {
        var _b;
        const result = yield mutate({
            variables: {
                input: Object.assign(Object.assign({ attribute,
                    attributeType, catalog: catalogId, clientMutationId,
                    filter,
                    presentationAttributes,
                    presentationAttributeFilterStrategy,
                    isReviewed }, (expectedMatchedProductCount !== undefined && { expectedMatchedProductCount })), { productTreeNode: productTreeNodeId, status }),
            },
            fetchPolicy: 'no-cache',
        });
        const data = (_b = result.data) === null || _b === void 0 ? void 0 : _b.productAttributesBulkReview;
        if (data === null || data === void 0 ? void 0 : data.error) {
            throw new Error(data.error);
        }
        return data;
    }), [mutate]);
    return {
        bulkReviewProductAttributes,
        loading,
        error,
    };
};
exports.useBulkReviewProductAttributes = useBulkReviewProductAttributes;
